<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sellType="{ row }">
        <el-tag
          v-if="row.sellType"
          size="mini"
          :type="
            row.sellType === 'B'
              ? ''
              : row.sellType === 'C'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_sellType || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          v-if="row.storeSkuStatus"
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus || '未配置状态' }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displaySalesTitle="{ row }">
        <span style="color: #303133">{{ row.salesTitle }}</span>
        <br />
        <span>SKU：</span><span style="color: #409EFF">{{ row.amzSkuNo }}</span>
        <br />
        <span>ASIN：</span><span style="color: #409EFF">{{ row.asinCode }}</span>
        <br />
        <span>FNSKU：</span
        ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
      </template>
      <template v-slot:displayStore="{ row }">
        <span>SHOP：</span
        ><span style="color: #303133">{{ row.storeName }}</span>
        <br />
        <span>BRAND：</span
        ><span style="color: #303133">{{ row.brandName }}</span>
        <br />
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_sellType"
            size="mini"
            :type="
              row.sellType === 'B'
                ? ''
                : row.sellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_sellType || '未配置' }}
          </el-tag>
        </div>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.storeSkuStatus === 'Y'
                ? 'success'
                : row.storeSkuStatus === 'S' ||
                  row.storeSkuStatus === 'B' ||
                  row.storeSkuStatus === 'W'
                ? 'danger'
                : row.storeSkuStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_storeSkuStatus || '未配置状态' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') }
      },
      tableColumns: tableColumns(this)
    }
  }
}
</script>
